// extracted by mini-css-extract-plugin
export default {"input-text":"input-text--323fce","inputText":"input-text--323fce","input-text_full-width":"input-text_full-width--2b9ff2","inputText_fullWidth":"input-text_full-width--2b9ff2"};